module.exports = __webpack_public_path__ + "img/payment.135dd1c5.png";